<template>
  <span style="display: flex; align-items: center"
    ><span style="display: block;">Version <slot></slot></span>
    <hr style="margin: 16px 0; flex: 1; margin-left: 1em;"
  /></span>
</template>
<script>
export default {
  name: "version-bar"
};
</script>
